import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoyaltyTokenService {
  private token = '';

  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    return this.http
      .get<{ token: string }>('/assets/config/loyalty.config.json')
      .toPromise()
      .then(res => {
        this.token = res.token;
      });
  }

  getToken(): string {
    return this.token;
  }
}
